import { DeviceClientType } from '../common';

type BrowserDeviceInfo = {
  ua: string;
  clientType: DeviceClientType,
  isInWeChatWebView: boolean,
  isInAlipayWebView: boolean,
  isInMobileBrowser: boolean,
  isInPCBrowser: boolean,
  isFastApp: boolean,
  isHarmonyApp: boolean,
  isAppleProduct: boolean,
}

let _cachedDeviceInfo: BrowserDeviceInfo | null = null;

export class BrowserHelper {

  public static get isInWeChatWebView(): boolean {
    return this.deviceInfo.isInWeChatWebView;
    // const ua = this.userAgent;
    // return /MicroMessenger/i.test(ua);
  }

  public static get isHarmonyApp(): boolean {
    const ua = this.userAgent;
    const isHarmonyOS = /OpenHarmony/i.test(ua);
    const isArkWeb = /ArkWeb/i.test(ua);
    // 鸿蒙快应用通常同时满足两者
    const isHarmonyApp = isHarmonyOS && isArkWeb;
    return isHarmonyApp;
  }

  public static get isFastApp(): boolean {
    return this.deviceInfo.isFastApp;
    // const ua = this.userAgent;
    // const isFastApp = /hap\//i.test(ua) || /QuickApp/i.test(ua);
    // return isFastApp;
  }

  public static get isInAlipayWebView(): boolean {
    return this.deviceInfo.isInAlipayWebView;
    // return /AlipayClient/.test(this.userAgent);
  }

  /**
   * 检测是否移动端网页，如果非web环境则返回undefined
   */
  public static get isInMobileBrowser(): boolean {
    return this.deviceInfo.isInMobileBrowser;
    // const ua = this.userAgent;
    // return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    //   ua,
    // );
  }

  public static get isInPCBrowser() {
    return this.deviceInfo.isInPCBrowser;
    //return !this.isInMobileBrowser && !this.isInWeChatWebView && !this.isInAlipayWebView && !this.isFastApp && !this.isHarmonyApp;
  }

  public static get clientType(): DeviceClientType {
    // if (this.isFastApp) {
    //   return 'fast-app';
    // }
    // if (this.isHarmonyApp) {
    //   return 'harmony-app';
    // }
    // if (this.isInWeChatWebView || this.isInAlipayWebView) {
    //   return 'mini-app'
    // }
    // if (this.isInMobileBrowser) {
    //   return 'mobile-web';
    // }
    // return 'pc-web';
    return this.deviceInfo.clientType;
  }

  static get isAppleProduct() {
    // const ua = this.userAgent;
    // return ua.includes('Mac OS X');
    return this.deviceInfo.isAppleProduct;
  }

  static get userAgent() {
    if (typeof navigator === 'undefined') {
      return '';
    }
    return navigator.userAgent;
  }


  private static get deviceInfo(): BrowserDeviceInfo {
    if (!_cachedDeviceInfo || _cachedDeviceInfo.ua !== this.userAgent) {
      const ua = this.userAgent;
      const isInWeChatWebView = /MicroMessenger/i.test(ua);
      const isInAlipayWebView = /AlipayClient/.test(ua);
      const isInMobileBrowser = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
        ua,
      );
      const isFastApp = /hap\//i.test(ua) || /QuickApp/i.test(ua);
      const isHarmonyOS = /OpenHarmony/i.test(ua);
      const isArkWeb = /ArkWeb/i.test(ua);
      const isHarmonyApp = isHarmonyOS && isArkWeb;
      const isAppleProduct = ua.includes('Mac OS X');
      const clientType: DeviceClientType = isFastApp
        ? 'fast-app'
        : isHarmonyApp
          ? 'harmony-app'
          : isInWeChatWebView || isInAlipayWebView
            ? 'mini-app'
            : isInMobileBrowser
              ? 'mobile-web'
              : 'pc-web';
      _cachedDeviceInfo = {
        ua,
        clientType,
        isInWeChatWebView,
        isInAlipayWebView,
        isInMobileBrowser,
        isInPCBrowser: !isInMobileBrowser && !isInWeChatWebView && !isInAlipayWebView && !isFastApp && !isHarmonyApp,
        isFastApp,
        isHarmonyApp,
        isAppleProduct,
      };
    }
    return _cachedDeviceInfo;
  }
}
